/* eslint-disable react/forbid-foreign-prop-types */
import PropTypes from 'prop-types';
import Dropdown from 'semantic-ui-react/dist/commonjs/modules/Dropdown';
import '@purple/semantic-ui-purple-theme/components/dropdown.css';

import get from 'lodash/get';
import invoke from 'lodash/invoke';

class CustomDropdown extends Dropdown {
  handleBlur = (e) => {
    // To prevent from closing the dropdown when user
    // navigate through arrow keys
    if (this.props.eventType === 'keyboard') {
      this.props.setEventType('');
      return;
    }

    const currentTarget = get(e, 'currentTarget');
    if (currentTarget && currentTarget.contains(document.activeElement)) return;

    const { closeOnBlur, multiple, selectOnBlur } = this.props;
    // do not "blur" when the mouse is down inside of the Dropdown
    if (this.isMouseDown) return;

    invoke(this.props, 'onBlur', e, this.props);
    if (selectOnBlur && !multiple) {
      this.makeSelectedItemActive(e);
      if (closeOnBlur) this.close();
    }

    this.setState({ focus: false });
    this.clearSearchQuery();
  }
}

// avoiding following props to get into DOM
CustomDropdown.handledProps.push('setEventType');
CustomDropdown.handledProps.push('eventType');
if (CustomDropdown.propTypes) {
  CustomDropdown.propTypes.setEventType = PropTypes.func;
  CustomDropdown.propTypes.eventType = PropTypes.string;
}

export default CustomDropdown;
